import { useState, useEffect, useRef } from "react"
import Modal from 'react-bootstrap/Modal';
import SuperSearchList from "../../../shared/SuperSearch/SuperSearchList";
import { enumUtil } from "../../../../utils/Enum"
import isNull from "../../../../utils/NullChecking"
import NotificationHandler from "../../../../utils/NotificationHandler"
import { ServerRequestProtected } from "../../../../utils/ServerDataRequest"
import { useSelector } from "react-redux";
import Loader from "../../../shared/Loader/Loader"
import SearchList from "../../../Scheduler/Settings/SearchList";
import ModalFooter from "../../Shared/ModalFooter";
import DropdownValueHandler from '../../../shared/SuperSearch/DropdownValueHandler';
import { FindSecondChild } from "../../../../utils/FindMenuOption";
// import { gridFilterActiveItemsLookupSelector } from "@mui/x-data-grid";
import { TotalTime } from "../../../../utils/Constants";
import FormValidator from "../../../../utils/FormValidator";

const ProviderSchedModal = (props) => {
    let DropDowns = useSelector(state => state.GeneralDropDownsReducer);
    let IsEditAllowed = FindSecondChild('Setup', 'Account', 'Provider')?.IsAdd
    let location_model = {
        LocationID: ''
    }

    const Time_Schedule = [
        { value: '', display: '' },
        { value: 'Same As Location Schedule', display: 'Same As Location Schedule' },
        { value: 'Default Schedule', display: 'Default Schedule' },

    ]

    const [TimeScheduleDD, setTimeScheduleDD] = useState(Time_Schedule)
    const { isopenProviderSch, isClosed, providerID, Name, is, conditionalLabel } = { ...props }
    const providersReducer = useSelector((state) => { return state.GeneralDropDownsReducer });
    const LocationList = providersReducer.Location;
    const [mainlocationmodel, setmainlocationmodel] = useState(location_model);
    // const []
    const [LocationSaveUpdateModal, setLocationSaveUpdateModal] = useState({})
    const [MondayID, setMondayID] = useState("0")
    const [tuesdayID, settuesdayID] = useState("0")
    const [providerlocation, setProviderlocation] = useState(false)
    const [WendesdayID, setWendesdayID] = useState("0")
    const [ThursdayID, setThursdayID] = useState("0")
    const [FridayID, setFridayID] = useState("0")
    const [SaturdayID, setSaturdayID] = useState("0")
    const [SundayID, setSundayID] = useState("0")
    const [List, setList] = useState([])
    const [ids, setIds] = useState([])
    const [mainAlllocation, setmainAlllocation] = useState([])
    const [InActive, setInActive] = useState([]);
    const [LocationFound, setLocationFound] = useState(false);
    const [StartTime, setStartTime] = useState(TotalTime);
    const [EndTime, setEndTime] = useState(TotalTime);
    const [BreakStartTime, setBreakStartTime] = useState(TotalTime);
    const [BreakEndTime, setBreakEndTime] = useState(TotalTime);

    // let List1=[];
    // const handleSelectedProviders = (selectedItems, type) => {
    //     let arr = [];
    //      List1 = selectedItems.map((item) => {
    //         arr.push(item.value)
    //         console.log(arr ,'arry');
    //         return arr;

    //     });
    //     setsaveAlllocation({...mainAlllocation, AllLoction:arr.toString()})
    //     setList(List1)
    //     console.log(List, 'item')
    // }

    // const handleSelectedProvidersLocation = (selectedItemsLocation, type) => {
    //     console.log(selectedItemsLocation, 'selectedItems');
    //     let arr = [];
    //     let arr1 = [];
    //     let arr2 = [];

    //     selectedItemsLocation?.map((item) => {
    //         let object = {

    //             ID: item.ProviderLocationID === '' ? '0' : item.ProviderLocationID,
    //             LocationID: item.value + "",
    //             InActive: '1'
    //         }
    //         arr.push(object)
    //         arr2.push(item)
    //         arr1.push(item)
    //     })
    //     setIds(arr);
    //     setList(arr1)
    //     // setmainAlllocation(arr2)
    // }
    const [ItemScc, setItemScc] = useState([])
    const [isFirstTimeOpened, setIsFirstTimeOpened] = useState(true);
    const handleSelectedProvidersLocation = (selectedItemsLocation, type) => {

        setItemScc(selectedItemsLocation)
        let arr = [];
        let arr1 = [];
        let arr2 = [];
        let count = 0;

        selectedItemsLocation?.map((item) => {
            let object = {
                ID: item.ProviderLocationID === '' ? '0' : item.ProviderLocationID,
                LocationID: item.value + "",
                InActive: item.InActive === '' ? '0' : '1'
            };
            arr.push(object);
            arr2.push(item);
            count++;
            if (item.InActive === 'True') arr1.push(item);

            // console.log(arr1,'aar1');
        });
        setIds(arr);
        setList(arr1);
        setInActive(count)
        setIsFirstTimeOpened(false)

        // setmainAlllocation(arr2)
    };

    console.log(mainAlllocation, 'dsipaly');


    const openProviderLocation = () => {
        setProviderlocation(!providerlocation);
    };

    const TimeSlot = [
        { value: '', display: '' },
        { value: '15', display: '15' },
        // { value: '30', display: '30' },
        // { value: '45', display: '45' },
        // { value: '60', display: '60' },
    ]


    let Monday_Model = {
        ID: "0",
        Day: "Monday",
        StartTime: null,
        EndTime: null,
        TimeInterval: null,
        TimeSlot: null,
        AppointmentAllowedPerSlot: "",
        OverBookAllowed: false,
        BreakStartTime: null,
        BreakEndTime: null,
        Notes: "Regular schedule"


    }

    let Tuesday_Model = {
        ID: "0",
        Day: "Tuesday",
        StartTime: null,
        EndTime: null,
        TimeInterval: null,
        TimeSlot: null,
        AppointmentAllowedPerSlot: " ",
        OverBookAllowed: false,
        BreakStartTime: null,
        BreakEndTime: null,
        Notes: "Regular schedule"


    }

    let Wednesday_Model = {
        ID: "0",
        Day: "Wednesday",
        StartTime: null,
        EndTime: null,
        TimeInterval: null,
        TimeSlot: null,
        AppointmentAllowedPerSlot: " ",
        OverBookAllowed: false,
        BreakStartTime: null,
        BreakEndTime: null,
        Notes: "Regular schedule"


    }
    let Thursday_Model = {
        ID: "0",
        Day: "Thursday",
        StartTime: null,
        EndTime: null,
        TimeInterval: null,
        TimeSlot: null,
        AppointmentAllowedPerSlot: " ",
        OverBookAllowed: false,
        BreakStartTime: null,
        BreakEndTime: null,
        Notes: "Regular schedule"


    }
    let Friday_Model = {
        ID: "0",
        Day: "Friday",
        StartTime: null,
        EndTime: null,
        TimeInterval: null,
        TimeSlot: null,
        AppointmentAllowedPerSlot: " ",
        OverBookAllowed: false,
        BreakStartTime: null,
        BreakEndTime: null,
        Notes: "Regular schedule"


    }
    let Saturday_Model = {
        ID: "0",
        Day: "Saturday",
        StartTime: null,
        EndTime: null,
        TimeInterval: null,
        TimeSlot: null,
        AppointmentAllowedPerSlot: " ",
        OverBookAllowed: false,
        BreakStartTime: null,
        BreakEndTime: null,
        Notes: "Regular schedule"


    }
    let Sunday_Model = {
        ID: "0",
        Day: "Sunday",
        StartTime: "",
        EndTime: "",
        TimeInterval: null,
        TimeSlot: null,
        AppointmentAllowedPerSlot: " ",
        OverBookAllowed: false,
        BreakStartTime: "",
        BreakEndTime: null,
        Notes: "Regular schedule"


    }

    const Time_Schedule_Modal = {

        Mon: [],
        MonBreak: [],

        Tue: [],
        TueBreak: [],

        Wed: [],
        WedBreak: [],

        Thu: [],
        ThuBreak: [],

        Fri: [],
        FriBreak: [],

        Sat: [],
        SatBreak: [],

        Sun: [],
        SunBreak: [],

    }
    // const Time_Schedule_Modal = {

    //     MonStartTime: [],
    //     MonEndTime: [],
    //     TueStartTime: [],
    //     TueEndTime: [],
    //     WedStartTime: [],
    //     WedEndTime: [],
    //     ThuStartTime: [],
    //     ThuEndTime: [],
    //     FriStartTime: [],
    //     FriEndTime: [],
    //     SatStartTime: [],
    //     SatEndTime: [],
    //     SunStartTime: [],
    //     SunEndTime: [],

    // }
    const Location_Schedule_Modal = {

        Mon: [],

        Tue: [],

        Wed: [],

        Thu: [],

        Fri: [],

        Sat: [],

        Sun: [],


    }

    let Scheduler_Validation_Modal = {

        MonTimeSlot: '',
        TueTimeSlot: '',
        WedTimeSlot: '',
        ThuTimeSlot: '',
        FriTimeSlot: '',
        SatTimeSlot: '',
        SunTimeSlot: '',

    }

    let valModal = {}

    const API_URL = enumUtil.controller.General

    const mainMondayRef = useRef({})
    const mainTuesdayRef = useRef({})
    const mainWednesdayRef = useRef({})
    const mainThursdayRef = useRef({})
    const mainFridayRef = useRef({})
    const mainSaturdayRef = useRef({})
    const mainSundayRef = useRef({})

    const [mainMondayModal, setmainMondayModal] = useState(Monday_Model);
    const [MondaySaveUpdateModal, setMondaySaveUpdateModal] = useState(Monday_Model)

    const [mainTuesdayModel, setmainTuesdayModel] = useState(Tuesday_Model);
    const [TuesdaySaveUpdateModal, setTuesdaySaveUpdateModal] = useState(Tuesday_Model);

    const [mainWednesdayModel, setmainWednesdayModel] = useState(Wednesday_Model);
    const [WednesdaySaveUpdateModal, setWednesdaySaveUpdateModal] = useState(Wednesday_Model)

    const [mainThursdayModel, setmainThursdayModel] = useState(Thursday_Model);
    const [ThursdaySaveUpdateModal, setThursdaySaveUpdateModal] = useState(Thursday_Model)

    const [mainFridayModel, setmainFridayModel] = useState(Friday_Model);
    const [FridaySaveUpdateModal, setFridaySaveUpdateModal] = useState(Friday_Model)


    const [mainSaturdayModel, setmainSaturdayModel] = useState(Saturday_Model);
    const [SaturdaySaveUpdateModal, setSaturdaySaveUpdateModal] = useState(Saturday_Model)


    const [mainSundayModel, setmainSundayModel] = useState(Sunday_Model);
    const [SundaySaveUpdateModal, setSundaySaveUpdateModal] = useState(Sunday_Model)



    const [isLoading, setIsLoading] = useState(false)
    const [totalCount, setTotalCount] = useState(0)
    const [ProvScheduleValidation, setProvScheduleValidation] = useState(Scheduler_Validation_Modal);
    const [ScheduleTimeRange, setScheduleTimeRange] = useState('Same As Location Schedule');
    const [WeeklyScheduleModal, setWeeklyScheduleModal] = useState(Time_Schedule_Modal);
    const [LocationScheduleModal, setLocationScheduleModal] = useState(Location_Schedule_Modal);
    const [SelectedLocationSchedule, setSelectedLocationSchedule] = useState([]);


    const handleVisitTypeChange = (e) => {

        let { name, value } = e.target;
        let modal = { ...mainMondayModal };
        let saveModal = { ...MondaySaveUpdateModal }
        if (name === 'OverBookAllowed') {
            modal[name] = !modal[name]
        } else {
            modal[name] = value
        }

        setmainMondayModal(modal)
        for (var property in Monday_Model) {
            if (name === property) {
                if (name === 'OverBookAllowed') {
                    saveModal[name] = modal[name] + ""
                } else {
                    saveModal[name] = value
                }

            }
        }

        setMondaySaveUpdateModal(saveModal)

    }

    const handleTuesdayChange = (e) => {
        let { name, value } = e.target;
        let modal = { ...mainTuesdayModel };
        let saveModal = { ...TuesdaySaveUpdateModal }
        if (name === 'OverBookAllowed') {
            modal[name] = !modal[name]
        } else {
            modal[name] = value
        }
        setmainTuesdayModel(modal)
        for (var property in Tuesday_Model) {
            if (name === property) {
                if (name === 'OverBookAllowed') {
                    saveModal[name] = modal[name] + ""
                } else {
                    saveModal[name] = value
                }


            }
        }

        setTuesdaySaveUpdateModal(saveModal)

    }
    const handleWednesdayChange = (e) => {
        let { name, value } = e.target;
        let modal = { ...mainWednesdayModel };
        let saveModal = { ...WednesdaySaveUpdateModal }
        {
            if (name === 'OverBookAllowed') {
                modal[name] = !modal[name]
            } else {
                modal[name] = value
            }
        }



        setmainWednesdayModel(modal)
        for (var property in Wednesday_Model) {
            if (name === property) {
                if (name === 'OverBookAllowed') {
                    saveModal[name] = modal[name] + ""
                } else {
                    saveModal[name] = value
                }

            }
        }

        setWednesdaySaveUpdateModal(saveModal)

    }
    const handleThursdayChange = (e) => {
        let { name, value } = e.target;
        let modal = { ...mainThursdayModel };
        let saveModal = { ...ThursdaySaveUpdateModal }
        {
            if (name === 'OverBookAllowed') {
                modal[name] = !modal[name]
            } else {
                modal[name] = value
            }
        }


        setmainThursdayModel(modal)
        for (var property in Thursday_Model) {
            if (name === property) {
                if (name === 'OverBookAllowed') {
                    saveModal[name] = modal[name] + ""
                } else {
                    saveModal[name] = value
                }


            }
        }

        setThursdaySaveUpdateModal(saveModal)

    }
    const handleFridayChange = (e) => {
        let { name, value } = e.target;
        let modal = { ...mainFridayModel };
        let saveModal = { ...FridaySaveUpdateModal }
        {
            if (name === 'OverBookAllowed') {
                modal[name] = !modal[name]
            } else {
                modal[name] = value
            }
        }

        setmainFridayModel(modal)
        for (var property in Friday_Model) {
            if (name === property) {
                if (name === 'OverBookAllowed') {
                    saveModal[name] = modal[name] + ""
                } else {
                    saveModal[name] = value
                }

            }
        }

        setFridaySaveUpdateModal(saveModal)

    }
    const handleSaturdayChange = (e) => {
        let { name, value } = e.target;
        let modal = { ...mainSaturdayModel };
        let saveModal = { ...SaturdaySaveUpdateModal }
        {
            if (name === 'OverBookAllowed') {
                modal[name] = !modal[name]
            } else {
                modal[name] = value
            }
        }



        setmainSaturdayModel(modal)
        for (var property in Saturday_Model) {
            if (name === property) {
                if (name === 'OverBookAllowed') {
                    saveModal[name] = modal[name] + ""
                } else {
                    saveModal[name] = value
                }


            }
        }

        setSaturdaySaveUpdateModal(saveModal)

    }
    const handleSundayChange = (e) => {
        let { name, value } = e.target;
        let modal = { ...mainSundayModel };
        let saveModal = { ...SundaySaveUpdateModal }
        {
            if (name === 'OverBookAllowed') {
                modal[name] = !modal[name]
            } else {
                modal[name] = value
            }
        }



        setmainSundayModel(modal)
        for (var property in Sunday_Model) {
            if (name === property) {
                if (name === 'OverBookAllowed') {
                    saveModal[name] = modal[name] + ""
                } else {
                    saveModal[name] = value
                }


            }
        }

        setSundaySaveUpdateModal(saveModal)

    }

    const handleLocationChange = (e) => {
        // console.log(e, '-------------------');
        let { name, value } = e.target;
        let modal = { ...mainlocationmodel };
        let saveModal = { ...LocationSaveUpdateModal }
        {
            modal[name] = value
        }

        setmainlocationmodel(modal)
        for (var property in location_model) {
            if (name === property) {
                saveModal[name] = value
            }
        }
        setLocationSaveUpdateModal(saveModal)
    }

    const handleSuperlistMonday = (e) => {
        // setIs(false)
        let { name, value } = e.target;
        let modal = { ...mainMondayModal };
        // let saveModal = { ...WednesdaySaveUpdateModal }
        modal[name] = value
        setmainMondayModal(modal)

    }
    const handleSuperlistTuesday = (e) => {
        // setIs(false)
        let { name, value } = e.target;
        let modal = { ...mainTuesdayModel };
        modal[name] = value
        setmainTuesdayModel(modal)
    }

    const handleSuperlistWednesday = (e) => {
        // setIs(false)
        let { name, value } = e.target;
        let modal = { ...mainWednesdayModel };
        // let saveModal = { ...WednesdaySaveUpdateModal }
        modal[name] = value
        setmainWednesdayModel(modal)

    }
    const handleSuperlistThursday = (e) => {
        // setIs(false)
        let { name, value } = e.target;
        let modal = { ...mainThursdayModel };
        modal[name] = value
        setmainThursdayModel(modal)
    }
    const handleSuperlistFriday = (e) => {
        // setIs(false)
        let { name, value } = e.target;
        let modal = { ...mainFridayModel };
        // let saveModal = { ...WednesdaySaveUpdateModal }
        modal[name] = value
        setmainFridayModel(modal)

    }
    const handleSuperlistSaturday = (e) => {
        // setIs(false)
        let { name, value } = e.target;
        let modal = { ...mainSaturdayModel };
        modal[name] = value
        setmainSaturdayModel(modal)
    }
    const handleSuperlistSunday = (e) => {
        // setIs(false)
        let { name, value } = e.target;
        let modal = { ...mainSundayModel };
        // let saveModal = { ...WednesdaySaveUpdateModal }
        modal[name] = value
        setmainSundayModel(modal)

    }


    const handleSelectedMonday = (selectedData, name, type) => {

        let modal = { ...mainMondayModal };
        let saveModal = { ...MondaySaveUpdateModal };

        if (!isNull(selectedData)) {

            if (name === 'StartTime') {
                if (!isNull(mainMondayModal['EndTime'])) {
                    let comparison = compareTimes(selectedData.value, modal['EndTime']);
                    if (!comparison) {
                        modal['EndTime'] = '';
                        saveModal['EndTime'] = '';
                    }
                }
            }

            modal[name] = selectedData.display
            saveModal[name] = selectedData.value;

        } else {

            modal[name] = ''
            saveModal[name] = ''

        }

        setmainMondayModal(modal);
        setMondaySaveUpdateModal(saveModal);

        return selectedData
    }
    const handleSelectedTuesday = (selectedData, name, type) => {

        let modal = { ...mainTuesdayModel };
        let saveModal = { ...TuesdaySaveUpdateModal }

        if (!isNull(selectedData)) {

            if (name === 'StartTime') {
                if (!isNull(mainTuesdayModel['EndTime'])) {
                    let comparison = compareTimes(selectedData.value, modal['EndTime']);
                    if (!comparison) {
                        modal['EndTime'] = '';
                        saveModal['EndTime'] = '';
                    }
                }
            }

            modal[name] = selectedData.display
            saveModal[name] = selectedData.value;

        }
        else {

            modal[name] = ''
            saveModal[name] = ''

        }

        setmainTuesdayModel(modal)
        setTuesdaySaveUpdateModal(saveModal)

        return selectedData
    }
    const handleSelectedWendesday = (selectedData, name, type) => {
        let modal = { ...mainWednesdayModel };
        let saveModal = { ...WednesdaySaveUpdateModal };
        if (!isNull(selectedData)) {

            if (name === 'StartTime') {
                if (!isNull(mainWednesdayModel['EndTime'])) {
                    let comparison = compareTimes(selectedData.value, modal['EndTime']);
                    if (!comparison) {
                        modal['EndTime'] = '';
                        saveModal['EndTime'] = '';
                    }
                }
            }

            modal[name] = selectedData.display
            saveModal[name] = selectedData.value;

        }
        else {
            modal[name] = ''
            saveModal[name] = ''
        }

        setmainWednesdayModel(modal)
        setWednesdaySaveUpdateModal(saveModal)

        return selectedData

    }

    const handleSelectedThursday = (selectedData, name, type) => {

        let modal = { ...mainThursdayModel };
        let saveModal = { ...ThursdaySaveUpdateModal };

        if (!isNull(selectedData)) {

            if (name === 'StartTime') {
                if (!isNull(mainThursdayModel['EndTime'])) {
                    let comparison = compareTimes(selectedData.value, modal['EndTime']);
                    if (!comparison) {
                        modal['EndTime'] = '';
                        saveModal['EndTime'] = '';
                    }
                }
            }

            modal[name] = selectedData.display
            saveModal[name] = selectedData.value;

        }
        else {
            modal[name] = ''
            saveModal[name] = ''
        }

        setmainThursdayModel(modal);
        setThursdaySaveUpdateModal(saveModal);

        return selectedData
    }
    const handleSelectedFriday = (selectedData, name, type) => {

        let modal = { ...mainFridayModel };
        let saveModal = { ...FridaySaveUpdateModal };

        if (!isNull(selectedData)) {

            if (name === 'StartTime') {
                if (!isNull(mainFridayModel['EndTime'])) {
                    let comparison = compareTimes(selectedData.value, modal['EndTime']);
                    if (!comparison) {
                        modal['EndTime'] = '';
                        saveModal['EndTime'] = '';
                    }
                }
            }

            modal[name] = selectedData.display;
            saveModal[name] = selectedData.value + "";

        }
        else {
            modal[name] = ''
            saveModal[name] = ''
        }

        setmainFridayModel(modal)
        setFridaySaveUpdateModal(saveModal)

        return selectedData
    }
    const handleSelectedSaturday = (selectedData, name, type) => {

        let modal = { ...mainSaturdayModel };
        let saveModal = { ...SaturdaySaveUpdateModal };

        if (!isNull(selectedData)) {

            if (name === 'StartTime') {
                if (!isNull(mainSaturdayModel['EndTime'])) {
                    let comparison = compareTimes(selectedData.value, modal['EndTime']);
                    if (!comparison) {
                        modal['EndTime'] = '';
                        saveModal['EndTime'] = '';
                    }
                }
            }

            modal[name] = selectedData.display
            saveModal[name] = selectedData.value + '';


        }
        else {
            modal[name] = ''
            saveModal[name] = ''
        }

        setmainSaturdayModel(modal);
        setSaturdaySaveUpdateModal(saveModal);

        return selectedData
    }
    const handleSelectedSunday = (selectedData, name, type) => {

        let modal = { ...mainSundayModel };
        let saveModal = { ...SundaySaveUpdateModal };

        if (!isNull(selectedData)) {

            if (name === 'StartTime') {
                if (!isNull(mainSundayModel['EndTime'])) {
                    let comparison = compareTimes(selectedData.value, modal['EndTime']);
                    if (!comparison) {
                        modal['EndTime'] = '';
                        saveModal['EndTime'] = '';
                    }
                }
            }

            modal[name] = selectedData.display
            saveModal[name] = selectedData.value + "";

        }
        else {

            modal[name] = ''
            saveModal[name] = ''

        }

        setmainSundayModel(modal);
        setSundaySaveUpdateModal(saveModal);

        return selectedData
    }


    const handleSelectedlocation = (selectedData, name, type) => {

        if (type === 'client' && !isNull(selectedData)) {
            if (name === 'LocationID') {
                setmainlocationmodel({ LocationID: selectedData.display })
                setLocationSaveUpdateModal({ LocationID: selectedData.value + "" })
                GetProviderLocationData(selectedData.value);
                GetProviderScheduler(selectedData.value);
            }
        } else if (type === 'server' && !isNull(selectedData)) {
            // if (name === 'POSCode') {
            //     UserSaveUpdateModal[name] = selectedData.ID
            //     setPOS(selectedData.ID)

        } else {
            setmainlocationmodel({ LocationID: "" })
            setLocationSaveUpdateModal({ LocationID: "" })
        }
        return selectedData
    }

    // const getProviderLocation = (locationId) => {
    //     setIsLoading(true)
    //     ServerRequestProtected(API_URL + "/GetProviderSchedule", 'post', {
    //         "TableName": enumUtil.enumAPITableName.ProviderSchedule,
    //         "SearchParam": "",
    //         "LocationID": locationId,
    //         "ProviderID": providerID + "",
    //     }).then((response) => {
    //         {
    //             setIsLoading(false)

    //             return response

    //         }
    //     }).catch((error) => {
    //         //  
    //         NotificationHandler(error.response.data, enumUtil.enumtoaster.error);
    //         if (!isNull(MondayID && tuesdayID && WendesdayID && ThursdayID && FridayID && SaturdayID && SundayID)) {
    //             setMondayID("0")
    //             settuesdayID("0")
    //             setWendesdayID("0")
    //             setThursdayID("0")
    //             setFridayID("0")
    //             setSaturdayID("0")
    //             setSundayID("0")
    //         }
    //         setIsLoading(false)
    //     })
    // }

    // const getLocationShcdeluar = (locationid) => {
    //     setIsLoading(true)
    //     ServerRequestProtected(API_URL + "/GetLocationSchedule", 'post', {
    //         "TableName": enumUtil.enumAPITableName.LOCATIONSCHEDULE,
    //         "ID": locationid + "",
    //     }).then((response) => {

    //         setIsLoading(false)

    //         const response2 = getProviderLocation(locationid)

    //         const mondayFiltered2 = response2?.Rows?.filter(item => item?.Day === "Monday");

    //         const mondayFiltered = response?.filter(item => item?.Day === "Monday");

    //         console.log(mondayFiltered,'monday filter');


    //         const data = mondayFiltered2?.length > 0? (mondayFiltered2[0].StartTime? mondayFiltered2[0]: mondayFiltered[0]):mondayFiltered[0]
    //         setMondaySaveUpdateModal({
    //             StartTime: mondayFiltered[0]?.StartTime,
    //             EndTime: mondayFiltered[0]?.EndTime,
    //             BreakEndTime: mondayFiltered[0]?.BreakEndTime
    //         })
    //         setmainMondayModal(data)
    //         console.log(data,'data');
    //         // setMondayID(data?.ProviderScheduleID)

    //         mainMondayRef.current = {
    //             StartTime: mondayFiltered[0].StartTime,
    //             EndTime: mondayFiltered[0].EndTime,
    //         }





    //         // GetProviderLocationData(locationid)
    //     }).catch((error) => {
    //         NotificationHandler(error.response.data, enumUtil.enumtoaster.error);
    //         if (!isNull(MondayID && tuesdayID && WendesdayID && ThursdayID && FridayID && SaturdayID && SundayID)) {
    //             setMondayID("0")
    //             settuesdayID("0")
    //             setWendesdayID("0")
    //             setThursdayID("0")
    //             setFridayID("0")
    //             setSaturdayID("0")
    //             setSundayID("0")
    //         }
    //         setIsLoading(false)
    //     })

    // }

    // const getLocation = (locationid) => {

    //     {
    //         setIsLoading(true)
    //         ServerRequestProtected(API_URL + "/GetLocationSchedule", 'post', {
    //             "TableName": enumUtil.enumAPITableName.LOCATIONSCHEDULE,
    //             "ID": locationid + "",
    //         }).then((responsegetloaction) => {
    //             const mondayFiltered2 = responsegetloaction?.filter(item => item?.Day === "Monday");

    //             {
    //                 setIsLoading(true)
    //                 setmainMondayModal(Monday_Model)
    //                 setmainTuesdayModel(Tuesday_Model)
    //                 setmainWednesdayModel(Wednesday_Model)
    //                 setmainThursdayModel(Thursday_Model)
    //                 setmainFridayModel(Friday_Model)
    //                 setmainSaturdayModel(Saturday_Model)
    //                 setmainSundayModel(Sunday_Model)
    //                 ServerRequestProtected(API_URL + "/GetProviderSchedule", 'post', {
    //                     "TableName": enumUtil.enumAPITableName.ProviderSchedule,
    //                     "SearchParam": "",
    //                     "LocationID": locationid,
    //                     "ProviderID": providerID + "",
    //                 }).then((responsegetprovider) => {
    //                     setIsLoading(false)
    //                     let filteredList = responsegetprovider?.ProviderLocation?.filter(item => item?.InActive === "True")
    //                     setList(filteredList)
    //                     mainAlllocation.push(responsegetprovider.ProviderLocation);
    //                     setTotalCount(responsegetprovider.ProviderLocation.length);

    //                     const mondayFiltered = responsegetprovider?.Rows?.filter(item => item?.Day === "Monday");
    //                     // console.log(mondayFiltered[0], 'monday');
    //                     setMondayID(mondayFiltered[0]?.ProviderScheduleID)
    //                     let loc = DropdownValueHandler(DropDowns?.Location, mondayFiltered[0].LocationID)
    //                     setmainlocationmodel({ LocationID: loc })
    //                     const data = mondayFiltered?.length > 0 ? (mondayFiltered[0].StartTime ? mondayFiltered[0] : mondayFiltered2[0]) : mondayFiltered2[0]
    //                     setmainMondayModal(data)



    //                     console.log(responsegetprovider, 'resposdad');
    //                 }).catch((error) => {
    //                     NotificationHandler(error.response.data, enumUtil.enumtoaster.error);
    //                     if (!isNull(MondayID && tuesdayID && WendesdayID && ThursdayID && FridayID && SaturdayID && SundayID)) {
    //                         setMondayID("0")
    //                         settuesdayID("0")
    //                         setWendesdayID("0")
    //                         setThursdayID("0")
    //                         setFridayID("0")
    //                         setSaturdayID("0")
    //                         setSundayID("0")
    //                     }
    //                 })


    //             }

    //             // setIsLoading(false)




    //             // let filteredList = response?.ProviderLocation?.filter(item => item?.InActive === "True")
    //             // setList(filteredList)
    //             // mainAlllocation.push(response.ProviderLocation);
    //             // setTotalCount(response.ProviderLocation.length);
    //             // const mondayFiltered = response?.Rows?.filter(item => item?.Day === "Monday");
    //             // // console.log(mondayFiltered[0], 'monday');
    //             // setMondayID(mondayFiltered[0]?.ProviderScheduleID)
    //             // let loc = DropdownValueHandler(DropDowns?.Location, mondayFiltered[0].LocationID)
    //             // setmainlocationmodel({ LocationID: loc })


    //             // const mondayFiltered2 = response2?.filter(item => item?.Day === "Monday");

    //             // console.log(mondayFiltered, 'dsdasda', mondayFiltered2, '=-=-=-=-=-=-=-');
    //             // console.log(mondayFiltered2,'mondayfilert22222222222222');

    //             // const data = mondayFiltered?.length > 0 ? (mondayFiltered[0].StartTime ? mondayFiltered[0] : mondayFiltered2[0]) : mondayFiltered2[0]
    //             // setmainMondayModal(data)

    //             // setMondaySaveUpdateModal({
    //             //     StartTime: data.StartTime,
    //             //     EndTime: data.EndTime,
    //             //     // BreakEndTime: data.BreakEndTime
    //             // })


    //             // mainMondayRef.current = {
    //             //     StartTime: mondayFiltered2[0].StartTime,
    //             //     EndTime: mondayFiltered2[0].EndTime,
    //             // }


    //         }).catch((error) => {
    //             NotificationHandler(error.response.data, enumUtil.enumtoaster.error);
    //             if (!isNull(MondayID && tuesdayID && WendesdayID && ThursdayID && FridayID && SaturdayID && SundayID)) {
    //                 setMondayID("0")
    //                 settuesdayID("0")
    //                 setWendesdayID("0")
    //                 setThursdayID("0")
    //                 setFridayID("0")
    //                 setSaturdayID("0")
    //                 setSundayID("0")
    //             }
    //             setIsLoading(false)
    //         })



    //     }

    // }
    const GetProviderScheduler = (locationID) => {

        let daysArray = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];

        const mainSetters = {
            Monday: setmainMondayModal,
            Tuesday: setmainTuesdayModel,
            Wednesday: setmainWednesdayModel,
            Thursday: setmainThursdayModel,
            Friday: setmainFridayModel,
            Saturday: setmainSaturdayModel,
            Sunday: setmainSundayModel,
        };

        const saveSetters = {
            Monday: setMondaySaveUpdateModal,
            Tuesday: setTuesdaySaveUpdateModal,
            Wednesday: setWednesdaySaveUpdateModal,
            Thursday: setThursdaySaveUpdateModal,
            Friday: setFridaySaveUpdateModal,
            Saturday: setSaturdaySaveUpdateModal,
            Sunday: setSundaySaveUpdateModal,
        };

        setmainMondayModal(Monday_Model);
        setmainTuesdayModel(Tuesday_Model);
        setmainWednesdayModel(Wednesday_Model);
        setmainThursdayModel(Thursday_Model);
        setmainFridayModel(Friday_Model);
        setmainSaturdayModel(Saturday_Model);
        setmainSundayModel(Sunday_Model);
        setMondaySaveUpdateModal(Monday_Model);
        setTuesdaySaveUpdateModal(Tuesday_Model);
        setWednesdaySaveUpdateModal(Wednesday_Model);
        setThursdaySaveUpdateModal(Thursday_Model);
        setFridaySaveUpdateModal(Friday_Model);
        setSaturdaySaveUpdateModal(Saturday_Model);
        setSundaySaveUpdateModal(Sunday_Model);

        ServerRequestProtected(API_URL + "/GetProviderSchedule", 'post', {
            "TableName": enumUtil.enumAPITableName.ProviderSchedule,
            "SearchParam": "",
            "LocationID": locationID ? locationID : "",
            "ProviderID": providerID + "",
        }).then((response) => {
            // setIsLoading(false)
            let scheduleRecord = response?.Rows;
            let filteredList = response?.ProviderLocation?.filter(item => item?.InActive === "True");
            setList(filteredList);
            let providerLocationList = response?.ProviderLocation || [];
            providerLocationList = [
                { display: "Select All", value: "Select All" },
                ...providerLocationList
            ];
            setmainAlllocation(providerLocationList);
            // setmainAlllocation(response?.ProviderLocation || []);
            setTotalCount(response.ProviderLocation.length);

            if (filteredList.length > 0 && isNull(locationID)) {

                setLocationSaveUpdateModal({ LocationID: filteredList[0].value })
                GetProviderLocationData(filteredList[0].value)
                setmainlocationmodel({ LocationID: filteredList[0].display })

            }

            if (scheduleRecord?.length > 0) {
                daysArray?.forEach((day) => {
                    let dayRecord = scheduleRecord?.filter((record) => record?.Day === day);

                    if (dayRecord?.length > 0) {

                        // Call the setters
                        mainSetters[day](dayRecord[0]);
                        saveSetters[day](dayRecord[0]);

                    }
                })

                // console.log("DAYSSSSSSS", mondayRecord, tuesdayRecord, wednesdayRecord, thursdayRecord, fridayRecord, saturdayRecord, sundayRecord)

            }

        }).catch((error) => {

            setIsLoading(false);
            // NotificationHandler(error.response.data, enumUtil.enumtoaster.error);
            if (!isNull(MondayID) && !isNull(tuesdayID) && !isNull(WendesdayID) && !isNull(ThursdayID) && !isNull(FridayID) && !isNull(SaturdayID) && !isNull(SundayID)) {
                setMondayID("0");
                settuesdayID("0");
                setWendesdayID("0");
                setThursdayID("0");
                setFridayID("0");
                setSaturdayID("0");
                setSundayID("0");
            }

        })

    }

    const GetProviderLocationData = (locationId) => {
        let locationModal = { ...LocationScheduleModal }

        setIsLoading(true)
        ServerRequestProtected(API_URL + "/GetLocationSchedule", 'post', {
            "TableName": enumUtil.enumAPITableName.LOCATIONSCHEDULE,
            "ID": locationId + "",
        }).then((response2) => {
            setIsLoading(false);
            setSelectedLocationSchedule(response2);

            const mondayFiltered2 = response2?.filter(item => item?.Day === "Monday");
            locationModal["Mon"] = mondayFiltered2[0];

            mainMondayRef.current = {
                StartTime: mondayFiltered2[0].StartTime,
                EndTime: mondayFiltered2[0].EndTime,
            }


            const tuesdayFiltered2 = response2?.filter(item => item?.Day === "Tuesday");
            locationModal["Tue"] = tuesdayFiltered2[0];

            mainTuesdayRef.current = {
                StartTime: tuesdayFiltered2[0].StartTime,
                EndTime: tuesdayFiltered2[0].EndTime,
            }

            const wednesdayFiltered2 = response2?.filter(item => item?.Day === "Wednesday");
            locationModal["Wed"] = wednesdayFiltered2[0];

            mainWednesdayRef.current = {
                StartTime: wednesdayFiltered2[0].StartTime,
                EndTime: wednesdayFiltered2[0].EndTime,
            }

            const thursdayFiltered2 = response2?.filter(item => item?.Day === "Thursday");
            locationModal["Thu"] = thursdayFiltered2[0];

            mainThursdayRef.current = {
                StartTime: thursdayFiltered2[0].StartTime,
                EndTime: thursdayFiltered2[0].EndTime,
            }

            const fridayFiltered2 = response2?.filter(item => item?.Day === "Friday");
            locationModal["Fri"] = fridayFiltered2[0];


            mainFridayRef.current = {
                StartTime: fridayFiltered2[0].StartTime,
                EndTime: fridayFiltered2[0].EndTime,
            }



            const saturdayFiltered2 = response2?.filter(item => item?.Day === "Saturday");
            locationModal["Sat"] = saturdayFiltered2[0];

            mainSaturdayRef.current = {
                StartTime: saturdayFiltered2[0].StartTime,
                EndTime: saturdayFiltered2[0].EndTime,
            }


            const sundayFiltered2 = response2?.filter(item => item?.Day === "Sunday");
            locationModal["Sun"] = sundayFiltered2[0];

            mainSundayRef.current = {
                StartTime: sundayFiltered2[0].StartTime,
                EndTime: sundayFiltered2[0].EndTime,
            }

            setLocationScheduleModal(locationModal);
            setLocationFound(true);
        }).catch((error) => {
            // NotificationHandler(error?.response?.data, enumUtil.enumtoaster.error);
            setLocationFound(false);
            setScheduleTimeRange('Default Schedule');
            setIsLoading(false);
        })

    }




    useEffect(() => {
        if (Name === 'Provider') {
            GetProviderScheduler(LocationSaveUpdateModal.LocationID)
        }

    }, [LocationSaveUpdateModal])

    function convert12HourTo24Hour(time12h) {
        const [time, period] = !isNull(time12h) ? time12h.split(' ') : "";
        const [hours, minutes] = !isNull(time) ? time.split(':') : "";

        let hours24 = parseInt(hours, 10);
        if (period === 'PM' && hours24 !== 12) {
            hours24 += 12;
        } else if (period === 'AM' && hours24 === 12) {
            hours24 = 0;
        }

        return `${hours24.toString().padStart(2, '0')}:${minutes}`;
    }

    function convertTo24Hour(time) {
        // console.log("24HrsFormate", time);
        const [timePart, modifier] = time.split(" ");
        let [hours, minutes] = timePart.split(":").map(Number);

        if (modifier === "PM" && hours !== 12) {
            hours += 12;
        }
        if (modifier === "AM" && hours === 12) {
            hours = 0;
        }

        return { hours, minutes };
    }

    function compareTimes(time1, time2) {
        if (!isNull(time1)) {

            const time1Obj = convertTo24Hour(time1);
            const time2Obj = convertTo24Hour(time2);

            const date1 = new Date();
            const date2 = new Date();

            date1.setHours(time1Obj.hours, time1Obj.minutes);
            date2.setHours(time2Obj.hours, time2Obj.minutes);

            // Compare times
            if (date2.getTime() > date1.getTime()) {
                return time2;
            }

        }
        else {
            return time2
        }
    }

    function compareTimeInRange(time1, time2, time3) {
        if (!isNull(time1) && !isNull(time3)) {

            const time1Obj = convertTo24Hour(time1);
            const time2Obj = convertTo24Hour(time2);
            const time3Obj = convertTo24Hour(time3);

            const date1 = new Date();
            const date2 = new Date();
            const date3 = new Date();

            date1.setHours(time1Obj.hours, time1Obj.minutes);
            date2.setHours(time2Obj.hours, time2Obj.minutes);
            date3.setHours(time3Obj.hours, time3Obj.minutes);
            // console.log("compareTimes", time1Obj,date1, time2,time2Obj,date2);
            // Compare times
            if (date2.getTime() >= date1.getTime() && date2.getTime() <= date3.getTime()) {
                return time2;
            }

        }
        else {
            return time2
        }
    }
    function convertPropertyToString(Object, Property1, Property2) {
        let List = [];
        let dayArray = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];

        dayArray.map((day, index) => {
            if (Object[day]) {


                const { AppointmentAllowedPerSlot, TimeInterval, StartTime, EndTime, BreakStartTime, BreakEndTime, TimeSlot, [Property1]: prop1, [Property2]: prop2, ...restOfObject } = Object[day];
                // { Day: 'Monday', ID: MondayID, ...{ OverBookAllowed, ...MondaySaveUpdateModal }, }
                let obj = {
                    Day: day,
                    ID: prop2 + '',
                    [Property1]: prop1 + '',
                    BreakEndTime: BreakEndTime ? BreakEndTime : '',
                    BreakStartTime: BreakStartTime ? BreakStartTime : '',
                    StartTime: StartTime ? StartTime : '',
                    EndTime: EndTime ? EndTime : '',
                    TimeSlot: TimeSlot ? TimeSlot : '',
                    ...restOfObject

                }
                List[index] = {
                    ...obj
                }
            }

        })

        return List
    }

    function convertToTimeObject(time1, time2) {
        if (!isNull(time1) && !isNull(time2)) {

            let FirstTime24 = convert12HourTo24Hour(time1)
            let SecondTime24 = convert12HourTo24Hour(time2)
            const parseTime = (time) => {
                const [hours, minutes] = time.split(':').map(Number);
                return hours * 60 + minutes;
            };
            const parsedTime1 = parseTime(FirstTime24);
            const parsedTime2 = parseTime(SecondTime24);
            if (parsedTime1 < parsedTime2) {
                return -1;
            } else if (parsedTime1 > parsedTime2) {
                return 1;
            } else {
                return 0; // Times are equal
            }
        }
    }

    function convertToTimeObjectForEndtime(time1, time2, modelEndTime) {
        // console.log(time1, time2,modelEndTime ,'++++++++++++++++++++++++++++++++++++' );
        let FirstTime24 = convert12HourTo24Hour(time1)
        let SecondTime24 = convert12HourTo24Hour(time2)
        let EndTime24 = convert12HourTo24Hour(modelEndTime)

        const parseTime = (time) => {
            const [hours, minutes] = time.split(':').map(Number);
            return hours * 60 + minutes;
        };
        const parsedTime1 = parseTime(FirstTime24);
        const parsedTime2 = parseTime(SecondTime24);
        const parsdeEndTime = parseTime(EndTime24);

        if (parsedTime2 > parsdeEndTime) {
            return 1
        }

        if (parsedTime1 < parsedTime2) {
            return -1;
        }
        else if (parsedTime1 > parsedTime2) {
            return 1;
        }
        else {
            return 0; // Times are equal
        }
    }

    const formValidation = () => {

        let validation = {

            MonTimeSlot: mainMondayModal?.StartTime ? FormValidator(mainMondayModal?.TimeSlot, enumUtil?.enumValidationType?.Required, 'Time Slot') : "",
            TueTimeSlot: mainTuesdayModel?.StartTime ? FormValidator(mainTuesdayModel?.TimeSlot, enumUtil?.enumValidationType?.Required, 'Time Slot') : "",
            WedTimeSlot: mainWednesdayModel?.StartTime ? FormValidator(mainWednesdayModel?.TimeSlot, enumUtil?.enumValidationType?.Required, 'Time Slot') : "",
            ThuTimeSlot: mainThursdayModel?.StartTime ? FormValidator(mainThursdayModel?.TimeSlot, enumUtil?.enumValidationType?.Required, 'Time Slot') : "",
            FriTimeSlot: mainFridayModel?.StartTime ? FormValidator(mainFridayModel?.TimeSlot, enumUtil?.enumValidationType?.Required, 'Time Slot') : "",
            SatTimeSlot: mainSaturdayModel?.StartTime ? FormValidator(mainSaturdayModel?.TimeSlot, enumUtil?.enumValidationType?.Required, 'Time Slot') : "",
            SunTimeSlot: mainSundayModel?.StartTime ? FormValidator(mainSundayModel?.TimeSlot, enumUtil?.enumValidationType?.Required, 'Time Slot') : "",
        }

        setProvScheduleValidation(validation);
        valModal = validation

    }
    // const copy = () => {
    //     setmainTuesdayModel(mainMondayModal)

    //     setTuesdaySaveUpdateModal(MondaySaveUpdateModal)

    //     console.log(MondaySaveUpdateModal, "monday modal");
    // }

    const handleSaveVistType = () => {
        formValidation();
        let validation = FormValidator([valModal], enumUtil?.enumValidationType?.NullCheck);

        if (validation) {
            return
        }
        else {
            let WeekObj = {
                Monday: MondaySaveUpdateModal,
                Tuesday: TuesdaySaveUpdateModal,
                Wednesday: WednesdaySaveUpdateModal,
                Thursday: ThursdaySaveUpdateModal,
                Friday: FridaySaveUpdateModal,
                Saturday: SaturdaySaveUpdateModal,
                Sunday: SundaySaveUpdateModal,
            }
            let list = convertPropertyToString(WeekObj, 'OverBookAllowed', 'ProviderScheduleID')
            // let list = [{ Day: 'Monday', ID: MondayID, ...{ OverBookAllowed, ...MondaySaveUpdateModal }, }, { Day: 'Tuesday', ID: tuesdayID, ...TuesdaySaveUpdateModal }, { Day: 'Wednesday', ID: WendesdayID, ...WednesdaySaveUpdateModal }, { Day: 'Thursday', ID: ThursdayID, ...ThursdaySaveUpdateModal }, { Day: 'Friday', ID: FridayID, ...FridaySaveUpdateModal }, { Day: 'Saturday', ID: SaturdayID, ...SaturdaySaveUpdateModal }, { Day: 'Sunday', ID: SundayID, ...SundaySaveUpdateModal }]

            {

                let saveModal = {
                    TableName: enumUtil.enumAPITableName.ProviderSchedule,
                    ProviderID: providerID + "",
                    LocationID: LocationSaveUpdateModal.LocationID ? LocationSaveUpdateModal.LocationID : List[0].value + "",
                    AllLoction: [...ids],
                    data: [...list],
                }

                if (LocationFound) {
                    setIsLoading(true)
                    ServerRequestProtected(API_URL + "/SaveProviderSchedule", 'post', saveModal)
                        .then((response) => {
                            setIsLoading(false)
                            if (!isNull(response.id)) {
                                NotificationHandler('Record Saved Successfully!', enumUtil.enumtoaster.success);
                                GetProviderScheduler(LocationSaveUpdateModal.LocationID);
                            }
                            // getLocationShcdeluar(LocationSaveUpdateModal.LocationID ? LocationSaveUpdateModal.LocationID : List[0].value + "")
                        }).catch((error) => {
                            setIsLoading(false)
                            NotificationHandler(error.response.data, enumUtil.enumtoaster.error)
                        })
                }
                else {
                    NotificationHandler(`Please setup the location schedule first`, enumUtil?.enumtoaster?.warning)
                }

            }
        }
    }

    useEffect(() => {

        let modal = { ...WeeklyScheduleModal }

        let dayArray = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']

        if (ScheduleTimeRange === "Same As Location Schedule") {
            if (LocationScheduleModal) {

                dayArray.forEach((day) => {
                    let startTime = LocationScheduleModal[day]['StartTime'];
                    let endTime = LocationScheduleModal[day]['EndTime'];
                    let BreakStart = LocationScheduleModal[day]['BreakStartTime'];
                    let BreakEnd = LocationScheduleModal[day]['BreakEndTime'];
                    // console.log("START/END", startTime, endTime, BreakStart, BreakEnd, LocationScheduleModal[day]['StartTime'], LocationScheduleModal[day]['EndTime']);
                    modal[day] = TotalTime?.filter((item) => {
                        return compareTimeInRange(startTime, item.value, endTime,)
                        // item.value > LocationScheduleModal['Mon']['StartTime']
                    })

                    modal[`${day}Break`] = TotalTime?.filter((item) => {
                        return compareTimeInRange(BreakStart, item.value, BreakEnd,)
                        // item.value > LocationScheduleModal['Mon']['StartTime']
                    })

                })
            }
        }

        else if (ScheduleTimeRange === "Default Schedule") {
            dayArray.forEach((day) => {

                modal[day] = TotalTime;
                modal[`${day}Break`] = TotalTime;

            })
        }

        setWeeklyScheduleModal(modal);

    }, [SelectedLocationSchedule, ScheduleTimeRange])

    useEffect(() => {

        if (LocationFound) {
            setTimeScheduleDD(Time_Schedule);
            setScheduleTimeRange('Same As Location Schedule');
        } else {
            setTimeScheduleDD(() => {
                return Time_Schedule.filter((item) => item.value !== 'Same As Location Schedule');
            })
            setScheduleTimeRange('Default Schedule');
        }

    }, [LocationFound])

    return (
        <>
            <Modal show={isopenProviderSch} onHide={isClosed} backdrop="static" keyboard={false} centered dialogClassName="app-modal modal-lg hk-modal-v1 provider_schedular">
                <Modal.Body>
                    {isLoading ? <Loader /> : null}
                    <div className="d-flex justify-content-between align-items-center">
                        <span className="heading sm text-center dark-clr fs-14 w-100">{conditionalLabel ? conditionalLabel : 'Provider'} Scheduler</span>
                        <button onClick={isClosed}><i className="icon-x-cros fs-20 dark-clr cursor-pointer"></i>
                        </button>
                    </div>
                    <div className=" mt-3 d-flex position-relative align-items-center justify-content-between">
                        <div className="col-md-4 position-relative">
                            <SuperSearchList
                                type="client"
                                id='LocationID'
                                name='LocationID'
                                searchValue={mainlocationmodel.LocationID}
                                data={List}
                                onChange={handleLocationChange}
                                getSelectedData={(selectedData, name, type) => {
                                    handleSelectedlocation(selectedData, name, type)
                                    // getLocationShcdeluar(selectedData.value)


                                }}
                                is={is}
                                sup_btn='sup_btn-Inp'
                                sup_inp='superSearchVisitInp'
                            />
                        </div>
                        <div className="col-md-4 position-relative">
                            <SuperSearchList
                                type="client"
                                id='ScheduleTimeRange'
                                name='ScheduleTimeRange'
                                searchValue={ScheduleTimeRange}
                                data={TimeScheduleDD}
                                onChange={(e) => setScheduleTimeRange(e.target.value)}
                                getSelectedData={(selectedData, name, type) => {
                                    setScheduleTimeRange(selectedData.value)
                                }}
                                is={is}
                                sup_btn='sup_btn-Inp'
                                sup_inp='superSearchVisitInp'
                            />
                        </div>
                        <div className="position-relative">
                            <p className="heading location cursor-pointer" onClick={openProviderLocation}><i className="icon-location"></i> {conditionalLabel ? conditionalLabel : 'Provider'} locations</p>
                            <div className="d-flex justify-content-end">
                                <p className=" ar-location heading">{List?.length} of {totalCount}</p>
                            </div>
                            {providerlocation &&
                                <div className="provider_location">

                                    <SearchList
                                        ItemLists={mainAlllocation}
                                        type={"provider"}
                                        Name={"ProviderSchedler"}
                                        // AllLocation={isFirstTimeOpened ? mainAlllocation[0] : ItemScc}
                                        AllLocation={mainAlllocation}
                                        // List={ItemScc} 
                                        // selected={List}
                                        getProvider={props.getProvider}
                                        handleSelectedProvidersLocation={handleSelectedProvidersLocation}

                                    />
                                </div>
                            }
                        </div>

                    </div>
                    <div className="mt-1 d-flex days_header ps-4">
                        <div className="col-md-2">
                            <p >Start Time</p>
                        </div>
                        <div className="col-md-2 ms-2">
                            <p >End Time </p>
                        </div>
                        <div className="col-md-2 ms-1">
                            <p >Break Start</p>
                        </div>
                        <div className="col-md-2 ms-3 text-center">
                            <p >Break End </p>
                        </div>
                        <div className="col-md-2 ms-1 text-center">
                            <p >Time Slot</p>
                        </div>
                    </div>
                    <div className="timing pt-2 pb-2 ps-4">
                        <div className="d-flex align-items-baseline mb-2">
                            <div className="time_slot w-100">

                                <div className="heading day mon">
                                    <span>MON</span>
                                </div>

                                <div className="col-md-2 input">
                                    <SuperSearchList
                                        type="client"
                                        id='StartTime'
                                        name='StartTime'
                                        searchValue={mainMondayModal?.StartTime || ''}
                                        data={WeeklyScheduleModal['Mon']}
                                        onChange={handleVisitTypeChange}
                                        getSelectedData={handleSelectedMonday}
                                        // getSelectedData={handleSelectedMonday}
                                        is={is}
                                        disabled={true}
                                        sup_btn='sup_btn-Inp'
                                        sup_inp='superSearchVisitInp'
                                    />

                                </div>


                                <div className="col-md-2 input">
                                    <SuperSearchList
                                        type="client"
                                        id='EndTime'
                                        name='EndTime'
                                        searchValue={mainMondayModal?.EndTime || ''}
                                        data={WeeklyScheduleModal['Mon'].filter((item) => {
                                            return compareTimes(mainMondayModal?.StartTime, item?.value);
                                        })}
                                        onChange={handleVisitTypeChange}
                                        getSelectedData={handleSelectedMonday}
                                        // getSelectedData={handleSelectedMonday}
                                        is={is}
                                        disabled={true}
                                        sup_btn='sup_btn-Inp'
                                        sup_inp='superSearchVisitInp'
                                    />

                                </div>
                                <div className="col-md-2 input">
                                    <SuperSearchList
                                        type="client"
                                        id='BreakStartTime'
                                        name='BreakStartTime'
                                        searchValue={mainMondayModal?.BreakStartTime || ''}
                                        data={WeeklyScheduleModal['MonBreak']}
                                        onChange={handleVisitTypeChange}
                                        getSelectedData={handleSelectedMonday}
                                        // getSelectedData={handleSelectedMonday}
                                        is={is}
                                        disabled={true}
                                        sup_btn='sup_btn-Inp'
                                        sup_inp='superSearchVisitInp'
                                    />
                                    {/* <select className="form-control"
                                        id='BreakStartTime'
                                        name='BreakStartTime'
                                        value={mainMondayModal?.BreakStartTime || ''}
                                        onChange={handleVisitTypeChange}
                                    >
                                        <option value={""} ></option>
                                        {WeeklyScheduleModal['MonBreak']?.map((e, index) => (
                                            <option value={e.value} key={index}>
                                                {e.display}
                                            </option>
                                        ))}
                                    </select> */}
                                </div>
                                <div className="col-md-2 check_box d-flex">
                                    <div className="custom_check_box ">
                                        <input type="checkbox"
                                            className='align-self-center form-check-input'
                                            id="OverBookAllowed"
                                            name="OverBookAllowed"
                                            checked={mainMondayModal?.OverBookAllowed}
                                            value={mainMondayModal?.OverBookAllowed}
                                            onChange={(e) => handleVisitTypeChange(e)}
                                        />
                                    </div>

                                </div>
                                <div className="col-md-2 input">

                                    <SuperSearchList
                                        type="client"
                                        id='BreakEndTime'
                                        name='BreakEndTime'
                                        searchValue={mainMondayModal?.BreakEndTime || ''}
                                        data={WeeklyScheduleModal['MonBreak']}
                                        onChange={handleVisitTypeChange}
                                        getSelectedData={handleSelectedMonday}
                                        // getSelectedData={handleSelectedMonday}
                                        is={is}
                                        disabled={true}
                                        sup_btn='sup_btn-Inp'
                                        sup_inp='superSearchVisitInp'
                                    />

                                </div>
                                <div className={`position-relative col-md-2 input ${ProvScheduleValidation?.MonTimeSlot ? 'error' : ''}`}>

                                    <SuperSearchList
                                        type="client"
                                        id='TimeSlot'
                                        name='TimeSlot'
                                        searchValue={mainMondayModal?.TimeSlot || ""}
                                        data={TimeSlot}
                                        onChange={handleSuperlistMonday}
                                        getSelectedData={handleSelectedMonday}
                                        // getSelectedData={handleSelectedMonday}
                                        is={is}
                                        disabled={true}
                                        sup_btn='sup_btn-Inp'
                                        sup_inp='superSearchVisitInp'
                                        inputError={ProvScheduleValidation?.MonTimeSlot ? true : false}
                                    />
                                    {ProvScheduleValidation?.MonTimeSlot}
                                </div>
                                {/* <div className="position-absolute ">
                                    <button >
                                        <i class="icon-Icon-ionic-ios-copy"></i>
                                    </button>

                                </div> */}
                            </div>
                        </div>
                        <div className="d-flex align-items-baseline mb-2">
                            <div className="time_slot w-100">
                                <div className="heading day tue">
                                    <span>TUE</span>
                                </div>

                                <div className="col-md-2 input">
                                    <SuperSearchList
                                        type="client"
                                        id='StartTime'
                                        name='StartTime'
                                        searchValue={mainTuesdayModel?.StartTime || ''}
                                        data={WeeklyScheduleModal['Tue']}
                                        onChange={handleTuesdayChange}
                                        getSelectedData={handleSelectedTuesday}
                                        // getSelectedData={handleSelectedMonday}
                                        is={is}
                                        disabled={true}
                                        sup_btn='sup_btn-Inp'
                                        sup_inp='superSearchVisitInp'
                                    />

                                </div>

                                <div className="col-md-2 input">
                                    <SuperSearchList
                                        type="client"
                                        id='EndTime'
                                        name='EndTime'
                                        searchValue={mainTuesdayModel?.EndTime || ''}
                                        data={WeeklyScheduleModal['Tue'].filter((item) => {
                                            return compareTimes(mainTuesdayModel?.StartTime, item?.value);
                                        })}
                                        onChange={handleTuesdayChange}
                                        getSelectedData={handleSelectedTuesday}
                                        // getSelectedData={handleSelectedMonday}
                                        is={is}
                                        disabled={true}
                                        sup_btn='sup_btn-Inp'
                                        sup_inp='superSearchVisitInp'
                                    />
                                    {/* <select className="form-control"
                                        id='EndTime'
                                        name='EndTime'
                                        value={mainTuesdayModel?.EndTime || ''}
                                        onChange={handleTuesdayChange}
                                    >
                                        <option value={""} ></option>
                                        {WeeklyScheduleModal['Tue'].filter((item) => {
                                            return compareTimes(mainTuesdayModel?.StartTime, item?.value);
                                        }).map((item, index) => {
                                            return (
                                                <option value={item.value} key={index}>
                                                    {item.display}
                                                </option>
                                            );
                                        })}
                                    </select> */}
                                </div>
                                <div className="col-md-2 input">
                                    <SuperSearchList
                                        type="client"
                                        id='BreakStartTime'
                                        name='BreakStartTime'
                                        searchValue={mainTuesdayModel?.BreakStartTime || ''}
                                        data={WeeklyScheduleModal['TueBreak']}
                                        onChange={handleTuesdayChange}
                                        getSelectedData={handleSelectedTuesday}
                                        // getSelectedData={handleSelectedMonday}
                                        is={is}
                                        disabled={true}
                                        sup_btn='sup_btn-Inp'
                                        sup_inp='superSearchVisitInp'
                                    />
                                    {/* <select className="form-control"
                                        id='BreakStartTime'
                                        name='BreakStartTime'
                                        value={mainTuesdayModel?.BreakStartTime || ''}
                                        onChange={handleTuesdayChange}
                                    >
                                        <option value={""} ></option>
                                        {WeeklyScheduleModal['TueBreak']?.map((e, index) => (
                                            <option value={e.value} key={index}>
                                                {e.display}
                                            </option>
                                        ))}
                                    </select> */}
                                </div>
                                <div className="col-md-2 check_box d-flex">
                                    <div className="custom_check_box ">
                                        <input type="checkbox"
                                            className='align-self-center form-check-input'
                                            id="OverBookAllowed"
                                            name="OverBookAllowed"
                                            checked={mainTuesdayModel?.OverBookAllowed}
                                            value={mainTuesdayModel?.OverBookAllowed}
                                            onChange={handleTuesdayChange}
                                        />
                                    </div>
                                </div>
                                <div className="col-md-2 input">
                                    <SuperSearchList
                                        type="client"
                                        id='BreakEndTime'
                                        name='BreakEndTime'
                                        searchValue={mainTuesdayModel?.BreakEndTime || ''}
                                        data={WeeklyScheduleModal['TueBreak']}
                                        onChange={handleTuesdayChange}
                                        getSelectedData={handleSelectedTuesday}
                                        // getSelectedData={handleSelectedMonday}
                                        is={is}
                                        disabled={true}
                                        sup_btn='sup_btn-Inp'
                                        sup_inp='superSearchVisitInp'
                                    />
                                    {/* <select className="form-control"
                                        id='BreakEndTime'
                                        name='BreakEndTime'
                                        value={mainTuesdayModel?.BreakEndTime || ''}
                                        onChange={handleTuesdayChange}
                                    >
                                        <option value={""} ></option>
                                        {WeeklyScheduleModal['TueBreak']?.map((e, index) => (
                                            <option value={e.value} key={index}>
                                                {e.display}
                                            </option>
                                        ))}
                                    </select> */}
                                </div>
                                <div className={`position-relative col-md-2 input ${ProvScheduleValidation?.TueTimeSlot ? 'error' : ''}`}>

                                    <SuperSearchList
                                        type="client"
                                        id='TimeSlot'
                                        name='TimeSlot'
                                        searchValue={mainTuesdayModel?.TimeSlot || ""}
                                        data={TimeSlot}
                                        onChange={handleSuperlistTuesday}
                                        getSelectedData={handleSelectedTuesday}
                                        // getSelectedData={handleSelectedTuesday}
                                        is={is}
                                        disabled={true}
                                        sup_btn='sup_btn-Inp'
                                        sup_inp='superSearchVisitInp'
                                        inputError={ProvScheduleValidation?.TueTimeSlot ? true : false}
                                    />
                                    {ProvScheduleValidation?.TueTimeSlot}
                                </div>
                            </div>
                        </div>
                        <div className="d-flex align-items-baseline mb-2">
                            <div className="time_slot w-100">
                                <div className="heading day wed">
                                    <span>WED</span>
                                </div>

                                <div className="col-md-2 input">
                                    <SuperSearchList
                                        type="client"
                                        id='StartTime'
                                        name='StartTime'
                                        searchValue={mainWednesdayModel?.StartTime || ''}
                                        data={WeeklyScheduleModal['Wed']}
                                        onChange={handleWednesdayChange}
                                        getSelectedData={handleSelectedWendesday}
                                        // getSelectedData={handleSelectedMonday}
                                        is={is}
                                        disabled={true}
                                        sup_btn='sup_btn-Inp'
                                        sup_inp='superSearchVisitInp'
                                    />
                                    {/* <select className="form-control"
                                        id='StartTime'
                                        name='StartTime'
                                        value={mainWednesdayModel?.StartTime || ''}
                                        onChange={handleWednesdayChange}
                                    >
                                        <option value={""} ></option>
                                        {WeeklyScheduleModal['Wed']?.map((e, index) => {
                                            return (
                                                <option value={e.value} key={index}>
                                                    {e.display}
                                                </option>
                                            );

                                        })}
                                    </select> */}
                                </div>

                                <div className="col-md-2 input">
                                    <SuperSearchList
                                        type="client"
                                        id='EndTime'
                                        name='EndTime'
                                        searchValue={mainWednesdayModel?.EndTime || ''}
                                        data={WeeklyScheduleModal['Wed'].filter((item) => {
                                            return compareTimes(mainWednesdayModel?.StartTime, item?.value);
                                        })}
                                        onChange={handleWednesdayChange}
                                        getSelectedData={handleSelectedWendesday}
                                        // getSelectedData={handleSelectedMonday}
                                        is={is}
                                        disabled={true}
                                        sup_btn='sup_btn-Inp'
                                        sup_inp='superSearchVisitInp'
                                    />
                                    {/* <select className="form-control"
                                        id='EndTime'
                                        name='EndTime'
                                        value={mainWednesdayModel?.EndTime || ''}
                                        onChange={handleWednesdayChange}
                                    >
                                        <option value={""} ></option>
                                        {WeeklyScheduleModal['Wed'].filter((item) => {
                                            return compareTimes(mainWednesdayModel?.StartTime, item?.value);
                                        }).map((item, index) => {
                                            return (
                                                <option value={item.value} key={index}>
                                                    {item.display}
                                                </option>
                                            );
                                        })}
                                    </select> */}
                                </div>
                                <div className="col-md-2 input">
                                    <SuperSearchList
                                        type="client"
                                        id='BreakStartTime'
                                        name='BreakStartTime'
                                        searchValue={mainWednesdayModel?.BreakStartTime || ''}
                                        data={WeeklyScheduleModal['WedBreak']}
                                        onChange={handleWednesdayChange}
                                        getSelectedData={handleSelectedWendesday}
                                        // getSelectedData={handleSelectedMonday}
                                        is={is}
                                        disabled={true}
                                        sup_btn='sup_btn-Inp'
                                        sup_inp='superSearchVisitInp'
                                    />
                                    {/* <select className="form-control"
                                        id='BreakStartTime'
                                        name='BreakStartTime'
                                        value={mainWednesdayModel?.BreakStartTime || ''}
                                        onChange={handleWednesdayChange}
                                    >
                                        <option value={""} ></option>
                                        {WeeklyScheduleModal['WedBreak']?.map((e, index) => (
                                            <option value={e.value} key={index}>
                                                {e.display}
                                            </option>
                                        ))}
                                    </select> */}
                                </div>
                                <div className="col-md-2 check_box d-flex">
                                    <div className="custom_check_box ">
                                        <input type="checkbox"
                                            className='align-self-center form-check-input'
                                            id="OverBookAllowed"
                                            name="OverBookAllowed"
                                            checked={mainWednesdayModel?.OverBookAllowed}
                                            value={mainWednesdayModel?.OverBookAllowed}
                                            onChange={handleWednesdayChange}
                                        />
                                    </div>
                                </div>
                                <div className="col-md-2 input">
                                    <SuperSearchList
                                        type="client"
                                        id='BreakEndTime'
                                        name='BreakEndTime'
                                        searchValue={mainWednesdayModel?.BreakEndTime || ''}
                                        data={WeeklyScheduleModal['WedBreak']}
                                        onChange={handleWednesdayChange}
                                        getSelectedData={handleSelectedWendesday}
                                        // getSelectedData={handleSelectedMonday}
                                        is={is}
                                        disabled={true}
                                        sup_btn='sup_btn-Inp'
                                        sup_inp='superSearchVisitInp'
                                    />
                                    {/* <select className="form-control"
                                        id='BreakEndTime'
                                        name='BreakEndTime'
                                        value={mainWednesdayModel?.BreakEndTime || ''}
                                        onChange={handleWednesdayChange}
                                    >
                                        <option value={""} ></option>
                                        {WeeklyScheduleModal['WedBreak']?.map((e, index) => (
                                            <option value={e.value} key={index}>
                                                {e.display}
                                            </option>
                                        ))}
                                    </select> */}
                                </div>
                                <div className={`position-relative col-md-2 input ${ProvScheduleValidation?.WedTimeSlot ? 'error' : ''}`}>

                                    <SuperSearchList
                                        type="client"
                                        id='TimeSlot'
                                        name='TimeSlot'
                                        searchValue={mainWednesdayModel?.TimeSlot || ''}
                                        data={TimeSlot}
                                        onChange={handleSuperlistWednesday}
                                        getSelectedData={handleSelectedWendesday}
                                        // getSelectedData={handleSelectedWendesday}
                                        is={is}
                                        disabled={true}
                                        sup_btn='sup_btn-Inp'
                                        sup_inp='superSearchVisitInp'
                                        inputError={ProvScheduleValidation?.WedTimeSlot ? true : false}
                                    />
                                    {ProvScheduleValidation?.WedTimeSlot}
                                </div>
                            </div>
                        </div>
                        <div className="d-flex align-items-baseline mb-2">
                            <div className="time_slot w-100">
                                <div className="heading day thu">
                                    <span>THU</span>
                                </div>

                                <div className="col-md-2 input">
                                    <SuperSearchList
                                        type="client"
                                        id='StartTime'
                                        name='StartTime'
                                        searchValue={mainThursdayModel?.StartTime || ''}
                                        data={WeeklyScheduleModal['Thu']}
                                        onChange={handleThursdayChange}
                                        getSelectedData={handleSelectedThursday}
                                        // getSelectedData={handleSelectedMonday}
                                        is={is}
                                        disabled={true}
                                        sup_btn='sup_btn-Inp'
                                        sup_inp='superSearchVisitInp'
                                    />
                                    {/* <select className="form-control"
                                        id='StartTime'
                                        name='StartTime'
                                        value={mainThursdayModel?.StartTime || ''}
                                        onChange={handleThursdayChange}
                                    >
                                        <option value={""} ></option>
                                        {WeeklyScheduleModal['Thu']?.map((e, index) => {
                                            return (
                                                <option value={e.value} key={index}>
                                                    {e.display}
                                                </option>
                                            );

                                        })}
                                    </select> */}
                                </div>

                                <div className="col-md-2 input">
                                    <SuperSearchList
                                        type="client"
                                        id='EndTime'
                                        name='EndTime'
                                        searchValue={mainThursdayModel?.EndTime || ''}
                                        data={WeeklyScheduleModal['Thu'].filter((item) => {
                                            return compareTimes(mainThursdayModel?.StartTime, item?.value);
                                        })}
                                        onChange={handleThursdayChange}
                                        getSelectedData={handleSelectedThursday}
                                        // getSelectedData={handleSelectedMonday}
                                        is={is}
                                        disabled={true}
                                        sup_btn='sup_btn-Inp'
                                        sup_inp='superSearchVisitInp'
                                    />
                                    {/* <select className="form-control"
                                        id='EndTime'
                                        name='EndTime'
                                        value={mainThursdayModel?.EndTime || ''}
                                        onChange={handleThursdayChange}
                                    >
                                        <option value={""} ></option>
                                        {WeeklyScheduleModal['Thu'].filter((item) => {
                                            return compareTimes(mainThursdayModel?.StartTime, item?.value);
                                        }).map((item, index) => {
                                            return (
                                                <option value={item.value} key={index}>
                                                    {item.display}
                                                </option>
                                            );
                                        })}
                                    </select> */}
                                </div>
                                <div className="col-md-2 input">
                                    <SuperSearchList
                                        type="client"
                                        id='BreakStartTime'
                                        name='BreakStartTime'
                                        searchValue={mainThursdayModel?.BreakStartTime || ''}
                                        data={WeeklyScheduleModal['ThuBreak']}
                                        onChange={handleThursdayChange}
                                        getSelectedData={handleSelectedThursday}
                                        // getSelectedData={handleSelectedMonday}
                                        is={is}
                                        disabled={true}
                                        sup_btn='sup_btn-Inp'
                                        sup_inp='superSearchVisitInp'
                                    />
                                    {/* <select className="form-control"
                                        id='BreakStartTime'
                                        name='BreakStartTime'
                                        value={mainThursdayModel?.BreakStartTime || ''}
                                        onChange={handleThursdayChange}
                                    >
                                        <option value={""} ></option>
                                        {WeeklyScheduleModal['ThuBreak']?.map((e, index) => (
                                            <option value={e.value} key={index}>
                                                {e.display}
                                            </option>
                                        ))}
                                    </select> */}
                                </div>
                                <div className="col-md-2 check_box d-flex">
                                    <div className="custom_check_box ">
                                        <input type="checkbox"
                                            className='align-self-center form-check-input'
                                            id="OverBookAllowed"
                                            name="OverBookAllowed"
                                            checked={mainThursdayModel?.OverBookAllowed}
                                            value={mainThursdayModel?.OverBookAllowed}
                                            onChange={handleThursdayChange}
                                        />
                                    </div>
                                </div>
                                <div className="col-md-2 input">
                                    <SuperSearchList
                                        type="client"
                                        id='BreakEndTime'
                                        name='BreakEndTime'
                                        searchValue={mainThursdayModel?.BreakEndTime || ''}
                                        data={WeeklyScheduleModal['ThuBreak']}
                                        onChange={handleThursdayChange}
                                        getSelectedData={handleSelectedThursday}
                                        // getSelectedData={handleSelectedMonday}
                                        is={is}
                                        disabled={true}
                                        sup_btn='sup_btn-Inp'
                                        sup_inp='superSearchVisitInp'
                                    />
                                    {/* <select className="form-control"
                                        id='BreakEndTime'
                                        name='BreakEndTime'
                                        value={mainThursdayModel?.BreakEndTime || ''}
                                        onChange={handleThursdayChange}
                                    >
                                        <option value={""} ></option>
                                        {WeeklyScheduleModal['ThuBreak']?.map((e, index) => (
                                            <option value={e.value} key={index}>
                                                {e.display}
                                            </option>
                                        ))}
                                    </select> */}
                                </div>
                                <div className={`position-relative col-md-2 input ${ProvScheduleValidation?.ThuTimeSlot ? 'error' : ''}`}>

                                    <SuperSearchList
                                        type="client"
                                        id='TimeSlot'
                                        name='TimeSlot'
                                        searchValue={mainThursdayModel?.TimeSlot || ''}
                                        data={TimeSlot}
                                        onChange={handleSuperlistThursday}
                                        getSelectedData={handleSelectedThursday}
                                        // getSelectedData={handleSelectedThursday}
                                        is={is}
                                        disabled={true}
                                        sup_btn='sup_btn-Inp'
                                        sup_inp='superSearchVisitInp'
                                        inputError={ProvScheduleValidation?.ThuTimeSlot ? true : false}
                                    />
                                    {ProvScheduleValidation?.ThuTimeSlot}
                                </div>
                            </div>
                        </div>
                        <div className="d-flex align-items-baseline mb-2">
                            <div className="time_slot w-100">
                                <div className="heading day fri">
                                    <span>FRI</span>
                                </div>

                                <div className="col-md-2 input">
                                    <SuperSearchList
                                        type="client"
                                        id='StartTime'
                                        name='StartTime'
                                        searchValue={mainFridayModel?.StartTime || ''}
                                        data={WeeklyScheduleModal['Fri']}
                                        onChange={handleFridayChange}
                                        getSelectedData={handleSelectedFriday}
                                        // getSelectedData={handleSelectedMonday}
                                        is={is}
                                        disabled={true}
                                        sup_btn='sup_btn-Inp'
                                        sup_inp='superSearchVisitInp'
                                    />
                                    {/* <select className="form-control"
                                        id='StartTime'
                                        name='StartTime'
                                        value={mainFridayModel?.StartTime || ''}
                                        onChange={handleFridayChange}
                                    >
                                        <option value={""} ></option>
                                        {WeeklyScheduleModal['Fri']?.map((e, index) => {

                                            return (
                                                <option value={e.value} key={index}>
                                                    {e.display}
                                                </option>
                                            );


                                        })}
                                    </select> */}
                                </div>

                                <div className="col-md-2 input">
                                    <SuperSearchList
                                        type="client"
                                        id='EndTime'
                                        name='EndTime'
                                        searchValue={mainFridayModel?.EndTime || ''}
                                        data={WeeklyScheduleModal['Fri'].filter((item) => {
                                            return compareTimes(mainFridayModel?.StartTime, item?.value);
                                        })}
                                        onChange={handleFridayChange}
                                        getSelectedData={handleSelectedFriday}
                                        // getSelectedData={handleSelectedMonday}
                                        is={is}
                                        disabled={true}
                                        sup_btn='sup_btn-Inp'
                                        sup_inp='superSearchVisitInp'
                                    />
                                    {/* <select className="form-control"
                                        id='EndTime'
                                        name='EndTime'
                                        value={mainFridayModel?.EndTime || ''}
                                        onChange={handleFridayChange}
                                    >
                                        <option value={""} ></option>
                                        {WeeklyScheduleModal['Fri'].filter((item) => {
                                            return compareTimes(mainFridayModel?.StartTime, item?.value);
                                        }).map((item, index) => {
                                            return (
                                                <option value={item.value} key={index}>
                                                    {item.display}
                                                </option>
                                            );
                                        })}
                                    </select> */}
                                </div>
                                <div className="col-md-2 input">
                                    <SuperSearchList
                                        type="client"
                                        id='BreakStartTime'
                                        name='BreakStartTime'
                                        searchValue={mainFridayModel?.BreakStartTime || ''}
                                        data={WeeklyScheduleModal['FriBreak']}
                                        onChange={handleFridayChange}
                                        getSelectedData={handleSelectedFriday}
                                        // getSelectedData={handleSelectedMonday}
                                        is={is}
                                        disabled={true}
                                        sup_btn='sup_btn-Inp'
                                        sup_inp='superSearchVisitInp'
                                    />
                                    {/* <select className="form-control"
                                        id='BreakStartTime'
                                        name='BreakStartTime'
                                        value={mainFridayModel?.BreakStartTime || ''}
                                        onChange={handleFridayChange}
                                    >
                                        <option value={""} ></option>
                                        {WeeklyScheduleModal['FriBreak']?.map((e, index) => (
                                            <option value={e.value} key={index}>
                                                {e.display}
                                            </option>
                                        ))}
                                    </select> */}
                                </div>
                                <div className="col-md-2 check_box d-flex">
                                    <div className="custom_check_box ">
                                        <input type="checkbox"
                                            className='align-self-center form-check-input'
                                            id="OverBookAllowed"
                                            name="OverBookAllowed"
                                            checked={mainFridayModel?.OverBookAllowed}
                                            value={mainFridayModel?.OverBookAllowed}
                                            onChange={handleFridayChange}
                                        />
                                    </div>
                                </div>
                                <div className="col-md-2 input">
                                    <SuperSearchList
                                        type="client"
                                        id='BreakEndTime'
                                        name='BreakEndTime'
                                        searchValue={mainFridayModel?.BreakEndTime || ''}
                                        data={WeeklyScheduleModal['FriBreak']}
                                        onChange={handleFridayChange}
                                        getSelectedData={handleSelectedFriday}
                                        // getSelectedData={handleSelectedMonday}
                                        is={is}
                                        disabled={true}
                                        sup_btn='sup_btn-Inp'
                                        sup_inp='superSearchVisitInp'
                                    />
                                    {/* <select className="form-control"
                                        name="BreakEndTime"
                                        id="BreakEndTime"
                                        value={mainFridayModel?.BreakEndTime || ''}
                                        onChange={handleFridayChange}
                                    >
                                        <option value={""} ></option>
                                        {WeeklyScheduleModal['FriBreak']?.map((e, index) => (
                                            <option value={e.value} key={index}>
                                                {e.display}
                                            </option>
                                        ))}
                                    </select> */}
                                </div>
                                <div className={`position-relative col-md-2 input ${ProvScheduleValidation?.FriTimeSlot ? 'error' : ''}`}>

                                    <SuperSearchList
                                        type="client"
                                        id='TimeSlot'
                                        name='TimeSlot'
                                        searchValue={mainFridayModel?.TimeSlot || ''}
                                        data={TimeSlot}
                                        onChange={handleSuperlistFriday}
                                        getSelectedData={handleSelectedFriday}
                                        is={is}
                                        disabled={true}
                                        sup_btn='sup_btn-Inp'
                                        sup_inp='superSearchVisitInp'
                                        inputError={ProvScheduleValidation?.FriTimeSlot ? true : false}
                                    />
                                    {ProvScheduleValidation?.FriTimeSlot}
                                </div>
                            </div>
                        </div>
                        <div className="d-flex align-items-baseline mb-2">
                            <div className="time_slot w-100">
                                <div className="heading day sat">
                                    <span>SAT</span>
                                </div>

                                <div className="col-md-2 input">

                                    <SuperSearchList
                                        type="client"
                                        id='StartTime'
                                        name='StartTime'
                                        searchValue={mainSaturdayModel?.StartTime || ''}
                                        data={WeeklyScheduleModal['Sat']}
                                        onChange={handleSaturdayChange}
                                        getSelectedData={handleSelectedSaturday}
                                        // getSelectedData={handleSelectedMonday}
                                        is={is}
                                        disabled={true}
                                        sup_btn='sup_btn-Inp'
                                        sup_inp='superSearchVisitInp'
                                    />
                                    {/* <select className="form-control"
                                        id='StartTime'
                                        name='StartTime'
                                        value={mainSaturdayModel?.StartTime || ''}
                                        onChange={handleSaturdayChange}
                                    >
                                        <option value={""} ></option>
                                        {WeeklyScheduleModal['Sat']?.map((e, index) => {

                                            return (
                                                <option value={e.value} key={index}>
                                                    {e.display}
                                                </option>
                                            );


                                        })}
                                    </select> */}
                                </div>
                                <div className="col-md-2 input">
                                    <SuperSearchList
                                        type="client"
                                        id='EndTime'
                                        name='EndTime'
                                        searchValue={mainSaturdayModel?.EndTime || ''}
                                        data={WeeklyScheduleModal['Sat'].filter((item) => {
                                            return compareTimes(mainSaturdayModel?.StartTime, item?.value);
                                        })}
                                        onChange={handleSaturdayChange}
                                        getSelectedData={handleSelectedSaturday}
                                        // getSelectedData={handleSelectedMonday}
                                        is={is}
                                        disabled={true}
                                        sup_btn='sup_btn-Inp'
                                        sup_inp='superSearchVisitInp'
                                    />
                                    {/* <select className="form-control"
                                        name="EndTime"
                                        id="EndTime"
                                        value={mainSaturdayModel?.EndTime || ''}
                                        onChange={handleSaturdayChange}
                                    >
                                        <option value={""} ></option>
                                        {WeeklyScheduleModal['Sat'].filter((item) => {
                                            return compareTimes(mainSaturdayModel?.StartTime, item?.value);
                                        }).map((item, index) => {
                                            return (
                                                <option value={item.value} key={index}>
                                                    {item.display}
                                                </option>
                                            );
                                        })}
                                    </select> */}
                                </div>
                                <div className="col-md-2 input">
                                    <SuperSearchList
                                        type="client"
                                        id='BreakStartTime'
                                        name='BreakStartTime'
                                        searchValue={mainSaturdayModel?.BreakStartTime || ''}
                                        data={WeeklyScheduleModal['SatBreak']}
                                        onChange={handleSaturdayChange}
                                        getSelectedData={handleSelectedSaturday}
                                        // getSelectedData={handleSelectedMonday}
                                        is={is}
                                        disabled={true}
                                        sup_btn='sup_btn-Inp'
                                        sup_inp='superSearchVisitInp'
                                    />
                                    {/* <select className="form-control"
                                        name="BreakStartTime"
                                        id="BreakStartTime"
                                        value={mainSaturdayModel?.BreakStartTime || ''}
                                        onChange={handleSaturdayChange}
                                    >
                                        <option value={""} ></option>
                                        {WeeklyScheduleModal['SatBreak']?.map((e, index) => (
                                            <option value={e.value} key={index}>
                                                {e.display}
                                            </option>
                                        ))}
                                    </select> */}
                                </div>
                                <div className="col-md-2 check_box d-flex">
                                    <div className="custom_check_box ">
                                        <input type="checkbox"
                                            className='align-self-center form-check-input'
                                            id="OverBookAllowed"
                                            name="OverBookAllowed"
                                            checked={mainSaturdayModel?.OverBookAllowed}
                                            value={mainSaturdayModel?.OverBookAllowed}
                                            onChange={handleSaturdayChange}
                                        />
                                    </div>
                                </div>
                                <div className="col-md-2 input">
                                    <SuperSearchList
                                        type="client"
                                        id='BreakEndTime'
                                        name='BreakEndTime'
                                        searchValue={mainSaturdayModel?.BreakEndTime || ''}
                                        data={WeeklyScheduleModal['SatBreak']}
                                        onChange={handleSaturdayChange}
                                        getSelectedData={handleSelectedSaturday}
                                        // getSelectedData={handleSelectedMonday}
                                        is={is}
                                        disabled={true}
                                        sup_btn='sup_btn-Inp'
                                        sup_inp='superSearchVisitInp'
                                    />
                                    {/* <select className="form-control"
                                        name="BreakEndTime"
                                        id="BreakEndTime"
                                        value={mainSaturdayModel?.BreakEndTime || ''}
                                        onChange={handleSaturdayChange}
                                    >
                                        <option value={""} ></option>
                                        {WeeklyScheduleModal['SatBreak']?.map((e, index) => (
                                            <option value={e.value} key={index}>
                                                {e.display}
                                            </option>
                                        ))}
                                    </select> */}
                                </div>
                                <div className={`position-relative col-md-2 input ${ProvScheduleValidation?.SatTimeSlot ? 'error' : ''}`}>

                                    <SuperSearchList
                                        type="client"
                                        id='TimeSlot'
                                        name='TimeSlot'
                                        searchValue={mainSaturdayModel?.TimeSlot || ''}
                                        data={TimeSlot}
                                        onChange={handleSuperlistSaturday}
                                        getSelectedData={handleSelectedSaturday}
                                        is={is}
                                        disabled={true}
                                        sup_btn='sup_btn-Inp'
                                        sup_inp='superSearchVisitInp'
                                        inputError={ProvScheduleValidation?.SatTimeSlot ? true : false}
                                    />
                                    {ProvScheduleValidation?.SatTimeSlot}
                                </div>
                            </div>
                        </div>
                        <div className="d-flex align-items-baseline">
                            <div className="time_slot w-100">
                                <div className="heading day sun">
                                    <span>SUN</span>
                                </div>
                                <div className="col-md-2 input">
                                    <SuperSearchList
                                        type="client"
                                        id='StartTime'
                                        name='StartTime'
                                        searchValue={mainSundayModel?.StartTime || ''}
                                        data={WeeklyScheduleModal['Sun']}
                                        onChange={handleSundayChange}
                                        getSelectedData={handleSelectedSunday}
                                        // getSelectedData={handleSelectedMonday}
                                        is={is}
                                        disabled={true}
                                        sup_btn='sup_btn-Inp'
                                        sup_inp='superSearchVisitInp'
                                    />
                                    {/* <select className="form-control"
                                        id='StartTime'
                                        name='StartTime'
                                        value={mainSundayModel?.StartTime || ''}
                                        onChange={handleSundayChange}
                                    >
                                        <option value={""} ></option>
                                        {WeeklyScheduleModal['Sun']?.map((e, index) => {

                                            return (
                                                <option value={e.value} key={index}>
                                                    {e.display}
                                                </option>
                                            );


                                        })}
                                    </select> */}
                                </div>

                                <div className="col-md-2 input">
                                    <SuperSearchList
                                        type="client"
                                        id='EndTime'
                                        name='EndTime'
                                        searchValue={mainSundayModel?.EndTime || ''}
                                        data={WeeklyScheduleModal['Sun'].filter((item) => {
                                            return compareTimes(mainSundayModel?.StartTime, item?.value);
                                        })}
                                        onChange={handleSundayChange}
                                        getSelectedData={handleSelectedSunday}
                                        // getSelectedData={handleSelectedMonday}
                                        is={is}
                                        disabled={true}
                                        sup_btn='sup_btn-Inp'
                                        sup_inp='superSearchVisitInp'
                                    />
                                    {/* <select className="form-control"
                                        name="EndTime"
                                        id="EndTime"
                                        value={mainSundayModel?.EndTime || ''}
                                        onChange={handleSundayChange}
                                    >
                                        <option value={""} ></option>
                                        {WeeklyScheduleModal['Sun'].filter((item) => {
                                            return compareTimes(mainSundayModel?.StartTime, item?.value);
                                        }).map((item, index) => {
                                            return (
                                                <option value={item.value} key={index}>
                                                    {item.display}
                                                </option>
                                            );
                                        })}
                                    </select> */}
                                </div>
                                <div className="col-md-2 input">
                                    <SuperSearchList
                                        type="client"
                                        id='BreakStartTime'
                                        name='BreakStartTime'
                                        searchValue={mainSundayModel?.BreakStartTime || ''}
                                        data={WeeklyScheduleModal['SunBreak']}
                                        onChange={handleSundayChange}
                                        getSelectedData={handleSelectedSunday}
                                        // getSelectedData={handleSelectedMonday}
                                        is={is}
                                        disabled={true}
                                        sup_btn='sup_btn-Inp'
                                        sup_inp='superSearchVisitInp'
                                    />
                                    {/* <select className="form-control"
                                        name="BreakStartTime"
                                        id="BreakStartTime"
                                        value={mainSundayModel?.BreakStartTime || ''}
                                        onChange={handleSundayChange}
                                    >
                                        <option value={""} ></option>
                                        {WeeklyScheduleModal['SunBreak']?.map((e, index) => (
                                            <option value={e.value} key={index}>
                                                {e.display}
                                            </option>
                                        ))}
                                    </select> */}
                                </div>
                                <div className="col-md-2 check_box d-flex">
                                    <div className="custom_check_box ">
                                        <input type="checkbox"
                                            className='align-self-center form-check-input'
                                            id="OverBookAllowed"
                                            name="OverBookAllowed"
                                            checked={mainSundayModel?.OverBookAllowed}
                                            value={mainSundayModel?.OverBookAllowed}
                                            onChange={handleSundayChange}
                                        />
                                    </div>
                                </div>
                                <div className="col-md-2 input">
                                    <SuperSearchList
                                        type="client"
                                        id='BreakEndTime'
                                        name='BreakEndTime'
                                        searchValue={mainSundayModel?.BreakEndTime || ''}
                                        data={WeeklyScheduleModal['SunBreak']}
                                        onChange={handleSundayChange}
                                        getSelectedData={handleSelectedSunday}
                                        // getSelectedData={handleSelectedMonday}
                                        is={is}
                                        disabled={true}
                                        sup_btn='sup_btn-Inp'
                                        sup_inp='superSearchVisitInp'
                                    />
                                    {/* <select className="form-control"
                                        name="BreakEndTime"
                                        id="BreakEndTime"
                                        value={mainSundayModel?.BreakEndTime || ''}
                                        onChange={handleSundayChange}
                                    >
                                        <option value={""} ></option>
                                        {WeeklyScheduleModal['SunBreak']?.map((e, index) => (
                                            <option value={e.value} key={index}>
                                                {e.display}
                                            </option>
                                        ))}
                                    </select> */}
                                </div>

                                <div className={`position-relative col-md-2 input ${ProvScheduleValidation?.SunTimeSlot ? 'error' : ''}`}>
                                    <SuperSearchList
                                        type="client"
                                        id='TimeSlot'
                                        name='TimeSlot'
                                        searchValue={mainSundayModel?.TimeSlot || ''}
                                        data={TimeSlot}
                                        onChange={handleSuperlistSunday}
                                        getSelectedData={handleSelectedSunday}
                                        is={is}
                                        disabled={true}
                                        sup_btn='sup_btn-Inp'
                                        sup_inp='superSearchVisitInp'
                                        inputError={ProvScheduleValidation?.SunTimeSlot ? true : false}
                                    />
                                    {ProvScheduleValidation?.SunTimeSlot}
                                </div>
                            </div>
                        </div>
                    </div>

                </Modal.Body>
                <ModalFooter handleSave={handleSaveVistType} isSaved={isClosed} IsEditAllowed={IsEditAllowed} />
                {/* <div className="d-flex align-items-center pb-15 px-10 pt-2 br-top-1 za_br_light justify-content-end gap-2 ar_footer">
                    <button className='btn btn-outline  px-10 dark-clr' onClick={isClosed}>Cancel</button>
                    <button className='btn btn-validate px-10' >Save</button>
                </div> */}
            </Modal>
        </>
    )
}

export default ProviderSchedModal